export default __webpack_public_path__ + "static/IMG_8151-17cba21e848dca46a986260678b17670.jpeg";